module.exports = require("@hsq/razzle-dazzle");